import React, { useEffect, useState } from 'react'; // Removed useRef
import axios from 'axios';
import './App.css';
import BatteryGraph from './components/BatteryGraph';

function App() {
  const [telemetry, setTelemetry] = useState({});
  const [logs, setLogs] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL || "https://api.teltonika.intelisparkz.com/api/telemetry/";
  const LOGS_URL = process.env.REACT_APP_LOGS_URL || "https://api.teltonika.intelisparkz.com/api/logs/";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [telRes, logRes] = await Promise.all([
          axios.get(API_URL),
          axios.get(LOGS_URL)
        ]);

        // 1. Process Active Fleet
        const uniqueDevices = {};
        if (Array.isArray(telRes.data)) {
          telRes.data.forEach(item => {
            if (!uniqueDevices[item.imei]) uniqueDevices[item.imei] = item;
          });
          setTelemetry(uniqueDevices);
        }

        // 2. Process Logs (Newest Top + 24hr Limit)
        if (logRes.data && Array.isArray(logRes.data.logs)) {
          const now = Date.now();
          const oneDayAgo = now - (24 * 60 * 60 * 1000); // 24 Hours in ms

          const formattedLogs = logRes.data.logs
            // Filter: Only keep logs from the last 24 hours
            .filter(log => new Date(log.timestamp).getTime() > oneDayAgo)
            .map(log => {
              const dt = new Date(log.timestamp);
              const dateStr = `${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}`;
              return {
                id: log.id,
                timestamp: dt.getTime(), // Store raw time for sorting
                text: `[${dateStr}] ${log.imei}: Lat:${Number(log.latitude).toFixed(4)} Lon:${Number(log.longitude).toFixed(4)} | Spd:${log.speed}km/h | ${log.battery_level}mV | IGN:${log.is_charging ? "ON" : "OFF"}`
              };
            })
            // Sort: Newest First (Descending Order)
            .sort((a, b) => b.timestamp - a.timestamp);

          setLogs(formattedLogs);
        }
      } catch (err) {
        console.error("Sync Error:", err);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 2000);
    return () => clearInterval(interval);
  }, [API_URL, LOGS_URL]);

  return (
    <div className="App">
      <header className="header">
        <h1>📡 InteliRide Admin</h1>
        <div className="status-dot online"></div>
      </header>

      <div className="main-dashboard-layout">
        {/* LOG SIDEBAR */}
        <div className="log-sidebar">
          <div className="panel-header">
            <span>LIVE LOGS (Newest First)</span>
            <span className="sync-text">SYNC: 2S</span>
          </div>

          {/* Removed 'ref' and invisible div. Newest items appear at top naturally. */}
          <div className="log-scroll-area">
            {logs.map(log => (
              <div key={log.id} className="terminal-log-line">{log.text}</div>
            ))}
          </div>
        </div>

        {/* FLEET PANEL */}
        <div className="fleet-display-panel">
          <h2 className="panel-title">Active Fleet</h2>

          {Object.keys(telemetry).length === 0 && (
            <div style={{ padding: '20px', color: '#666' }}>
              Waiting for active fleet data...
            </div>
          )}

          {Object.values(telemetry).map((item) => (
            <div key={item.imei} className="vehicle-row-container">
              <div className="dashboard-card status-card">
                <div className="status-card-header">
                  <h3>🚙 {item.imei}</h3>
                </div>
                <div className="status-card-body">
                  <div className="info-row">📍 {Number(item.latitude).toFixed(5)}, {Number(item.longitude).toFixed(5)}</div>
                  <div className="metrics-middle">
                    <div className="info-row">🚀 {item.speed} km/h</div>
                    <div className={`ign-badge ${item.is_charging ? 'on' : 'off'}`}>
                      {item.is_charging ? "IGNITION ON" : "IGNITION OFF"}
                    </div>
                  </div>
                  <div className="metrics-bottom">
                    <div className="battery-info">🔋 {item.battery_level} mV</div>
                    <div className="timestamp-small">
                      {new Date(item.timestamp).toLocaleTimeString()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboard-card history-card">
                <BatteryGraph imei={item.imei} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;